import React from 'react';
import { Link, useLocation } from 'react-router-dom';
type Props = {
  /** In-page anchor on the homepage, e.g. "#work" */
  hash: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  'aria-label'?: string;
};

/**
 * Link to a homepage section. On the homepage it stays a plain anchor (so smooth
 * scrolling handles it); on subpages it routes back home and scrolls to the section.
 */
export function SectionLink({
  hash,
  className,
  children,
  onClick,
  ...rest
}: Props) {
  const {
    pathname
  } = useLocation();
  if (pathname === '/') {
    return <a href={hash} className={className} onClick={onClick} aria-label={rest['aria-label']} data-id="element-318" data-mp="binpkafwnfqo">
        {children}
      </a>;
  }
  return <Link to={hash === '#top' ? '/' : `/${hash}`} className={className} onClick={onClick} aria-label={rest['aria-label']} data-id="element-319" data-mp="fl2ar171qrl4">
      {children}
    </Link>;
}